const REGEXP = /[a-zA-Z]/;

export const getQuotedText = (text: string): string => {
  if (REGEXP.test(text)) {
    return `"${text}"`;
  }

  return `«${text}»`;
};
